import React, { useEffect, useState } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import AuthenticationService from '../service/AuthenticationService'
import { AUTH_CHANGED_EVENT } from '../util/authEvents'

// Staff = admin or manager (isAdmin is true for both). Customers and guests shop; staff run the shop.
export const isStaff = () => AuthenticationService.isUserLoggedIn() && AuthenticationService.getIsAdmin() === 'true'

// Re-renders whenever the navbar syncs the account or the user signs in/out, so the role is re-read
// (even when only "role unknown" turns into "customer").
export const useIsStaff = () => {
    const [, setVersion] = useState(0)
    useEffect(() => {
        const onChange = () => setVersion(v => v + 1)
        window.addEventListener(AUTH_CHANGED_EVENT, onChange)
        return () => window.removeEventListener(AUTH_CHANGED_EVENT, onChange)
    }, [])
    return isStaff()
}

// Storefront pages (home, products, search, cart, checkout, my orders): staff go to their dashboard.
export const ShopperOnly = ({ children }) => {
    const staff = useIsStaff()
    return staff ? <Redirect to='/dashboard' /> : children
}

// Pages for a signed-in shopper (AI Help): guests sign in first, staff go to their dashboard, new accounts finish
// the declaration first.
export const SignedInShopper = ({ children }) => {
    const staff = useIsStaff()
    const location = useLocation()
    if (!AuthenticationService.isUserLoggedIn()) {
        return <Redirect to={{ pathname: '/login', state: { id: location.pathname } }} />
    }
    if (AuthenticationService.getIsAdmin() === null) return null
    if (staff) return <Redirect to='/dashboard' />
    if (localStorage.getItem('hasProfile') !== 'true') return <Redirect to='/userDetails' />
    return children
}

// Shop admin pages: guests sign in first, customers go back to the shop.
export const StaffOnly = ({ children }) => {
    const staff = useIsStaff()
    const location = useLocation()
    if (!AuthenticationService.isUserLoggedIn()) {
        return <Redirect to={{ pathname: '/login', state: { id: location.pathname } }} />
    }
    // the role is only known once the navbar has synced the account; until then show nothing
    if (AuthenticationService.getIsAdmin() === null) return null
    return staff ? children : <Redirect to='/' />
}
